import App from './App';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { setupInterceptors } from './config/http';
import reportWebVitals from './reportWebVitals';
import store from './store/store';
import './index.css';
import 'react-toastify/dist/ReactToastify.css';
import { GoogleOAuthProvider } from '@react-oauth/google';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
setupInterceptors(store);

root.render(
  <>
    <GoogleOAuthProvider clientId="797498375175-id35nrpjhehq5m8d5kkulhjbs7slrmm8.apps.googleusercontent.com">
      <ToastContainer autoClose={2000} />
      <Provider store={store}>
        <App />
      </Provider>
    </GoogleOAuthProvider>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
